module.exports = __webpack_public_path__ + "img/fantasy.3bc70316.png";